import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./breadcrumbs.css";

export default function Breadcrumbs({ items = [], separator = "•" }) {
  const { t } = useTranslation("ui");
  if (!items.length) return null;

  return (
    <nav className="breadcrumbs" aria-label={t("breadcrumbs.ariaLabel")}>
      <ol className="breadcrumbs__list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={`${item.label}-${index}`} className="breadcrumbs__item">
              {index > 0 && (
                <span className="breadcrumbs__separator" aria-hidden="true">
                  {separator}
                </span>
              )}
              {isLast || !item.to ? (
                <span className="breadcrumbs__current" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="breadcrumbs__link">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
